// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import currencyEuroIcon from "@/assets/icons/currency-euro.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CurrencyEuroIconProps = Omit<IconProps, "name">;

export function CurrencyEuroIcon(props: CurrencyEuroIconProps): React.ReactNode {
  return <Icon name={currencyEuroIcon} {...props} />;
}
